<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="createYear"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
      title="Ajout d'une nouvelle année"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md12 ma-2">
            <va-input
              label="Année"
              type="number"
              v-model="newYear"
            />
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual } from "lodash";

export default {
  name: "creation-publication",
  props: ["value"],
  data() {
    return {
      showEdition: false,
      newYear: null
    };
  },
  mounted() {
    this.newYear = null
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {

    async createYear() {
      this.showEdition = true;
      if (!this.$store.getters.user.publications_numeros) {
        this.launchEpicmaxToast("Droit insuffisant");
        return;
      }
      if (!this.newYear) {
        this.launchEpicmaxToast("Veuillez entrer une année");
        return;
      }

      if (!Number.isInteger(parseInt(this.newYear))) {
        this.launchEpicmaxToast("L'année doit être un entier");
        return;
      }
      try {
        await axios.put("/api/publications-web/create", {
          year: this.newYear,
        });
        this.launchEpicmaxToast("Année ajoutée");
        this.$emit("creation", true);

        this.closeModal();
      } catch (error) {
        console.log(error);
        if (error.response) {
          this.launchEpicmaxToast(error.response.data);
        }
      }
    },
    resetValues() {
      //reset all values
      this.newYear = null;
    },
    closeModal() {
      this.resetValues();
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    saveMessage: function () {
      if (!this.idnumero) {
        return "Ajouter l'année";
      }
      if (!isEqual(this.publication, this.publication_bak)) {
        return "Sauvegarder les modifications";
      } else {
        return "Fermer";
      }
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetValues();
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 45vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.input-t1 {
  margin: 5px;
}
.numeroDisp-mod {
  background-color: $vue-green;
  //color: white;
  border: solid 1px $vue-green;
  width: 8em;
  height: 8em;
  span {
    outline: none !important;
  }
}
</style>
